/**
 * 图标集合。
 *
 * 全部为**描边风格**（`fill: none` + `stroke: currentColor`），路径按 24×24 视窗手写，
 * 因此不依赖任何图标库，也不会因为引入第三方包而带进未使用的字形。
 * 每个图标是一组 `<path d>`，由 `components/Icon.tsx` 统一渲染。
 */
export const ICON_PATHS = {
  // —— 平台六大模块（与 platform 前端的导航一一对应）——
  fleet: ['M4 4h7v7H4z', 'M13 4h7v7h-7z', 'M4 13h7v7H4z', 'M13 13h7v7h-7z'],
  registry: ['M4 7h16', 'M4 12h16', 'M4 17h10', 'M16.5 16.5 18 18l3-3.5'],
  tracking: [
    'M12 12m-7.5 0a7.5 7.5 0 1 0 15 0a7.5 7.5 0 1 0-15 0',
    'M12 12m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
    'M12 2.5V6',
    'M12 18v3.5',
    'M2.5 12H6',
    'M18 12h3.5',
  ],
  users: [
    'M8 7.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0',
    'M3 20c0-2.9 2.2-5 5-5s5 2.1 5 5',
    'M15.5 4.6a3.5 3.5 0 0 1 0 6.8',
    'M17 15c2.4.5 4 2.4 4 5',
  ],
  audit: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  settings: [
    'M12 12m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
    'M12 2.8v3',
    'M12 18.2v3',
    'M4 7.4l2.6 1.5',
    'M17.4 15.1 20 16.6',
    'M4 16.6l2.6-1.5',
    'M17.4 8.9 20 7.4',
  ],

  // —— 能力与概念 ——
  shield: ['M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6l7-3Z', 'M9 12l2 2 4-4'],
  link: [
    'M9.5 14.5l5-5',
    'M7 12l-2 2a3.5 3.5 0 0 0 5 5l2-2',
    'M17 12l2-2a3.5 3.5 0 0 0-5-5l-2 2',
  ],
  layers: ['M12 3l8 4.5-8 4.5-8-4.5L12 3Z', 'M4 12l8 4.5 8-4.5', 'M4 16.5 12 21l8-4.5'],
  plug: ['M9 3v6', 'M15 3v6', 'M7 9h10v3a5 5 0 0 1-10 0V9Z', 'M12 17v4'],
  cpu: [
    'M6 6h12v12H6z',
    'M9.5 9.5h5v5h-5z',
    'M12 3v3',
    'M12 18v3',
    'M3 12h3',
    'M18 12h3',
  ],
  database: [
    'M4 6.5c0-1.4 3.6-2.5 8-2.5s8 1.1 8 2.5-3.6 2.5-8 2.5-8-1.1-8-2.5Z',
    'M4 6.5v11c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-11',
    'M4 12c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5',
  ],
  pin: ['M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z', 'M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'],
  route: ['M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M16 7h-6a4 4 0 0 0 0 8h4'],
  gauge: ['M4.5 18a9 9 0 1 1 15 0', 'M12 13l3.5-3.5'],
  lock: ['M6 11h12v9H6z', 'M9 11V8a3 3 0 0 1 6 0v3'],
  clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 7.5V12l3 2'],
  bell: ['M6.5 17V11a5.5 5.5 0 0 1 11 0v6', 'M5 17h14', 'M10 20h4'],
  globe: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
    'M3.4 9h17.2',
    'M3.4 15h17.2',
    'M12 3c2.6 2.4 2.6 15.6 0 18',
    'M12 3c-2.6 2.4-2.6 15.6 0 18',
  ],
  zap: ['M13 3 5 13h5l-1 8 8-10h-5l1-8Z'],
  building: ['M5 21V4h9v17', 'M14 9h5v12', 'M8 8h3', 'M8 12h3', 'M8 16h3'],
  graduation: [
    'M3 9l9-4 9 4-9 4-9-4Z',
    'M7 11.5V16c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5v-4.5',
  ],
  wrench: ['M15 3a5.5 5.5 0 0 0-4.8 8.2L3 18.4 5.6 21l7.2-7.2A5.5 5.5 0 1 0 15 3Z'],
  sliders: [
    'M4 8h10',
    'M18 8h2',
    'M4 16h4',
    'M12 16h8',
    'M16 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0',
    'M10 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0',
  ],
  scale: ['M12 3v18', 'M6 21h12', 'M4 8h16', 'M4 8 7 15H1L4 8Z', 'M20 8l3 7h-6l3-7Z'],
  key: [
    'M15.5 8.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0',
    'M12.9 11.6 4.5 20',
    'M6.9 17.6 5 15.7',
    'M9.8 14.7 7.9 12.8',
  ],
  signal: ['M3.5 20v-4', 'M9 20V11.5', 'M14.5 20V7', 'M20 20V3.5'],

  // —— 界面 ——
  mail: ['M3.5 6.5h17v11h-17z', 'M4 7.5l8 5.5 8-5.5'],
  code: ['M9 8l-4 4 4 4', 'M15 8l4 4-4 4'],
  sun: [
    'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z',
    'M12 2v2.5',
    'M12 19.5V22',
    'M2 12h2.5',
    'M19.5 12H22',
    'M4.9 4.9l1.8 1.8',
    'M17.3 17.3l1.8 1.8',
    'M4.9 19.1l1.8-1.8',
    'M17.3 6.7l1.8-1.8',
  ],
  moon: ['M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z', 'M16.2 16.2 21 21'],
  close: ['M6 6l12 12', 'M18 6 6 18'],
  arrowRight: ['M4 12h15', 'M13 6l6 6-6 6'],
  arrowLeft: ['M20 12H5', 'M11 6l-6 6 6 6'],
  chevronDown: ['M6 9l6 6 6-6'],
  check: ['M5 13l4.5 4.5L19 7'],
  copy: ['M9 9h11v11H9z', 'M15 9V5H4v11h5'],
  external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v5.5H4.5V6H10'],
  download: ['M12 3v12', 'M7.5 10.5 12 15l4.5-4.5', 'M4.5 19.5h15'],
  info: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
    'M12 11v5.5',
    'M12 7.75v.5',
  ],
  alert: [
    'M12 4.2 21 19.5H3L12 4.2Z',
    'M12 10v4',
    'M12 16.75v.5',
  ],
  refresh: ['M20 12a8 8 0 0 1-13.6 5.7', 'M4 12a8 8 0 0 1 13.6-5.7', 'M17.5 3v3.5H14', 'M6.5 21v-3.5H10'],
} as const;

export type IconName = keyof typeof ICON_PATHS;
